module.exports = {
	init: function () {
		
		$(".nav-toggle").on("click", function () {
			console.log()
			if ($(".header").hasClass("active")) {
				$(".header").removeClass("active");
				setTimeout(() => {
					$(".header").css({ height: "auto" });
				}, 500);
			} else {
				$(".header").addClass("active");
				$(".header").css({ height: '100vh'});
			}
		});
	},
};
